
import { Component, Mixins } from "vue-property-decorator";
import RatingMixin from "./ratings.mixin";

@Component
class RatingTableComponent extends Mixins(RatingMixin) {
  sortBy = "";
  sortDesc = false;
}

export default RatingTableComponent;
